module.exports = __webpack_public_path__ + "img/Partner_02.28867a9a.png";